export default __webpack_public_path__ + "static/media/heart_minus_FILL1.76854f49.svg";